export class GCol {
  public Pos: number ;
  public ColType: string ;
  public ColName: string ;
  public ColValue: string ;
}

export class GRow {
  public Cols: Array<GCol>;
  public GetColValue(colName: string): string {
    const c: GCol[] = this.Cols.filter((e: GCol) => e.ColName === colName);
    return c && c.length > 0 ? c[0].ColValue : 'nf';
  }
  public HasColumn(colName: string): boolean {
    const c: GCol[] = this.Cols.filter((e: GCol) => e.ColName === colName);
    return c != null;
  }
}

export class GData {
  public Rows: Array<GRow>;
}
